module.exports = __webpack_public_path__ + "static/img/support_banner.1d6da41.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/support_banner.jpg
// module id = EUNf
// module chunks = 1